import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SettingsContext = createContext(null);

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    server_name: 'mcommunity',
    server_ip: 'cfx.re/join/xxxxx',
    discord_link: 'https://discord.gg/xxxxx',
    discord_widget_id: '',
    logo_url: '',
    description: 'Bienvenue sur mcommunity, l\'un des meilleurs serveurs GTA V RP FiveM!'
  });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Failed to fetch settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const updateSettings = async (newSettings, token) => {
    try {
      const response = await axios.put(`${API}/admin/settings`, newSettings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSettings(response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to update settings:', error);
      throw error;
    }
  };

  const value = {
    settings,
    loading,
    updateSettings,
    refreshSettings: fetchSettings
  };

  return (
    <SettingsContext.Provider value={value}>
      {children}
    </SettingsContext.Provider>
  );
};
